import { CoreIcon } from '../core-icon';
import pointCircleSVG from '../../../src/images/icons/point-circle.svg';

export const PointCircleIcon = props => {
  return <CoreIcon src={pointCircleSVG} {...props} />;
};
